import React, { useState } from "react";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import AssignmentIcon from "@material-ui/icons/Assignment";
import PublishIcon from "@material-ui/icons/Publish";
import { Button, IconButton } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import CloseIcon from "@material-ui/icons/Close";
import { archiveConstants } from "../contstants/archive.contstants";
export function FileStorageHeader(props) {
  const [isCopied, toggleCopied] = useState(false);

  const { onUpload, selectedFile, onSelectFile, onDeleteFile, fontEnabled, toggleParent, display } = props;

  const copyLink = () => {
    navigator.clipboard.writeText(selectedFile.url);
    toggleCopied(true);
    setTimeout(() => toggleCopied(false), 3000);
  };
  const buttonStyle = {
    marginRight: 10,
    borderRadius: 8,
    border: "1px solid #535562",
    background: "#4c4e5b",
    padding: "6px 12px !important",
    marginTop: "10px !important",
  };
  let inputFilter = "image/*";
  if (display === archiveConstants.FONT)
    inputFilter = archiveConstants.FONT_TYPES.map((x) => {
      return "." + x;
    }).join(",");
  else if (display === archiveConstants.OTHER)
    inputFilter = archiveConstants.OTHER_TYPES.map((x) => {
      return "." + x;
    }).join(",");

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <label htmlFor="file-upload" style={buttonStyle} className="editor-full-btn primary-text">
        <PublishIcon />
        <SystemLabel name="Upload" />
      </label>
      <input id="file-upload" className="file-upload" type="file" accept={inputFilter} onChange={(e) => onUpload(e)} />

      {selectedFile && (selectedFile.type.toString().includes("image/") || selectedFile.type.toString().includes("font/")) ? (
        <Button style={buttonStyle} startIcon={<CheckIcon />} className="editor-full-btn primary-text" onClick={() => onSelectFile()}>
          <SystemLabel name="Select" />
        </Button>
      ) : null}
      {selectedFile ? (
        <Button className="editor-full-btn primary-text" style={buttonStyle} onClick={() => onDeleteFile()} startIcon={<DeleteOutlineIcon />}>
          <SystemLabel name="Delete" />
        </Button>
      ) : null}
      {selectedFile ? (
        <Button startIcon={isCopied ? <AssignmentTurnedInIcon /> : <AssignmentIcon />} className="editor-full-btn primary-text" style={buttonStyle} onClick={copyLink}>
          {isCopied ? <SystemLabel name="IsCopied" /> : <SystemLabel name="CopyLink" />}
        </Button>
      ) : null}
      <IconButton style={{ position: "absolute", left: "calc(100% - 48px)" }} className="primary-text" onClick={toggleParent}>
        <CloseIcon className="primary-text" />
      </IconButton>
    </div>
  );
}
